import AxiosService from "./AxiosService";

let AuthenticateService = {
  authenticate(username, password) {
    return AxiosService.post("api/login", { username, password });
  },
  renew() {
    return AxiosService.post("api/authenticate/renew");
  },
};

export default AuthenticateService;
